function mmSlideProduct() {
  let thumbnailElems = document.querySelectorAll(".mm-thumbnail-elem");
  let splideElemMain = document.querySelector("#main-slider");
  let splideElemThumbnails = document.querySelector("#thumbnail-slider");

  if (!splideElemMain) return;

  const main = new Splide(splideElemMain, {
    type: "slide",
    pagination: false,
    arrows: false,
    perPage: 1,
    breakpoints: {
      768: {
        pagination: true,
        gap: 10,
        padding: {
          right: 40,
        },
      },
    },
  });

  function setActiveThumbnail(index) {
    thumbnailElems.forEach(function (thumb, i) {
      thumb.classList.toggle("mm-active", i === index);
    });
  }

  if (splideElemThumbnails) {
    // Vignettes : synchro native Splide (sync + isNavigation) pour réactivité immédiate
    const thumbnailSplide = new Splide(splideElemThumbnails, {
      type: "slide",
      rewind: false,
      pagination: false,
      arrows: false,
      gap: "8px",
      trimSpace: true,
      autoWidth: true,
      isNavigation: true,
      breakpoints: {
        768: {
          arrows: false,
          gap: "6px",
          autoWidth: true,
        },
      },
    });

    main.sync(thumbnailSplide);
    main.mount();
    thumbnailSplide.mount();
  } else {
    // Vignettes à gauche : pas de Splide sur les vignettes, juste clic + suivi au scroll
    thumbnailElems.forEach(function (thumbnailElem) {
      thumbnailElem.addEventListener("click", function () {
        var index = parseInt(thumbnailElem.dataset.index, 10);
        main.go(index);
        setActiveThumbnail(index);
      });
    });

    main.on("moved", function (newIndex) {
      setActiveThumbnail(newIndex);
      var activeThumb = thumbnailElems[newIndex];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    });

    main.mount();
  }
}

function mmSlideProductReassurance() {
  var splideElemMain = document.querySelector("#slider-reassurance");
  // SLIDER PRODUCT
  if (splideElemMain) {
    var main = new Splide(splideElemMain, {
      type: "slide",
      rewind: true,
      pagination: true,
      arrows: false,
      autoplay: true,
      interval: 5000,
      perPage: 1,
    });
    main.mount();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  mmSlideProduct();
  mmSlideProductReassurance();

  /** Récap « Payez X aujourd’hui, puis Y … » — #price_today# = prix du label abonnement (mm-reload) ; #price_monthly# = ce prix × (1 + augmentation%/100). 3 % selon l’index variante (1–3, repli 3 si 4+). */
  window.mmUpdatePaymentSummary = function mmUpdatePaymentSummary() {
    const root = document.querySelector("[data-mm-payment-summary]");
    if (!root) return;

    const selectedMethod = document.querySelector('input[name="purchase_option"]:checked')?.value || "one_time";
    if (selectedMethod !== "subscription") {
      root.hidden = true;
      return;
    }

    const allowRaw = root.getAttribute("data-mm-payment-summary-variant-allow") || "";
    const allowList = allowRaw
      .trim()
      .split(",")
      .map((s) => parseInt(String(s).trim(), 10))
      .filter((n) => Number.isFinite(n) && n > 0);
    const allowSet = allowList.length ? new Set(allowList) : null;

    let positionById = {};
    try {
      const posEl = document.getElementById("mmVariantPositionById");
      if (posEl) positionById = JSON.parse(posEl.textContent || "{}") || {};
    } catch (e) {
      positionById = {};
    }
    const vid = document.getElementById("product_id")?.value;
    const idxFromJson =
      vid != null && Object.prototype.hasOwnProperty.call(positionById, String(vid))
        ? positionById[String(vid)]
        : vid != null && Object.prototype.hasOwnProperty.call(positionById, String(parseInt(vid, 10)))
          ? positionById[String(parseInt(vid, 10))]
          : undefined;
    let variantIndex1Based = Number.isFinite(Number(idxFromJson)) ? Number(idxFromJson) : null;
    if (variantIndex1Based == null) {
      const variantOptions = document.querySelector('label[for="one_time"] .mm-selling-plans-options-inputs-bis');
      if (variantOptions) {
        const inputs = Array.from(variantOptions.querySelectorAll('input[type="radio"]'));
        const selectedIdx = inputs.findIndex((i) => String(i.getAttribute("data-variant-id") || "") === String(vid));
        variantIndex1Based = selectedIdx >= 0 ? selectedIdx + 1 : 1;
      } else {
        variantIndex1Based = 1;
      }
    }

    if (allowSet && variantIndex1Based != null && !allowSet.has(variantIndex1Based)) {
      root.hidden = true;
      return;
    }

    root.hidden = false;

    let incBucket = 1;
    if (variantIndex1Based != null && Number.isFinite(Number(variantIndex1Based))) {
      const v = Number(variantIndex1Based);
      incBucket = v < 1 ? 1 : v > 3 ? 3 : v;
    }
    const incStr = String(root.getAttribute(`data-mm-payment-summary-inc-v${incBucket}`) || "")
      .trim()
      .replace(/\u202f/g, "")
      .replace(",", ".");
    const incRaw = parseFloat(incStr);
    const incPct = Math.min(1000, Math.max(0, Number.isFinite(incRaw) ? incRaw : 0));

    const priceEl = document.getElementById("mm-subscription-header-price");
    const raw = priceEl?.textContent;
    const parsePriceToCents = (txt) => {
      if (!txt) return NaN;
      const cleaned = String(txt)
        .replace(/\u202f/g, "")
        .replace(/\s/g, "")
        .replace(/[^\d,.-]/g, "")
        .replace(",", ".");
      const num = Number(cleaned);
      if (!Number.isFinite(num)) return NaN;
      return Math.round(num * 100);
    };

    const baseCents = parsePriceToCents(raw);
    if (!Number.isFinite(baseCents)) return;

    const todayCents = baseCents;
    const nextCents = Math.round((baseCents * (100 + incPct)) / 100);
    const fmt = (cents) => {
      if (typeof window.mmFormatMoneyEurFromCents === "function") {
        return window.mmFormatMoneyEurFromCents(cents);
      }
      const c = Math.round(Number(cents));
      if (!Number.isFinite(c)) return "€";
      if (c % 100 === 0) {
        return (c / 100).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + "€";
      }
      return (c / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "€";
    };

    root.querySelectorAll("[data-mm-payment-price-today]").forEach((el) => {
      el.textContent = fmt(todayCents);
    });
    root.querySelectorAll("[data-mm-payment-price-monthly]").forEach((el) => {
      el.textContent = fmt(nextCents);
    });
  };

  window.mmUpdateUnitPrice = function mmUpdateUnitPrice() {
    try {
      const unitPricesScript = document.getElementById("mmVariantUnitPrices");
      const unitDivisorsScript = document.getElementById("mmVariantUnitDivisors");
      if (!unitPricesScript && !unitDivisorsScript) return;

      let unitPricesByVariantId = {};
      let unitDivisorsByVariantId = {};
      try {
        unitPricesByVariantId = unitPricesScript ? JSON.parse(unitPricesScript.textContent || "{}") : {};
        unitDivisorsByVariantId = unitDivisorsScript ? JSON.parse(unitDivisorsScript.textContent || "{}") : {};
      } catch (e) {
        return;
      }

      const variantId = document.getElementById("product_id")?.value;
      if (!variantId) return;

      const selectedMethod = document.querySelector('input[name="purchase_option"]:checked')?.value || "one_time";

      document.querySelectorAll("[data-mm-unit-price-line]").forEach((line) => {
        const targets = line.querySelectorAll("[data-mm-unit-price]");
        const keyA = String(variantId);
        const keyB = String(parseInt(variantId, 10));
        const lookedUpText =
          (Object.prototype.hasOwnProperty.call(unitPricesByVariantId, keyA) ? unitPricesByVariantId[keyA] : undefined) ??
          (Object.prototype.hasOwnProperty.call(unitPricesByVariantId, keyB) ? unitPricesByVariantId[keyB] : undefined);

        const divisorRaw =
          (Object.prototype.hasOwnProperty.call(unitDivisorsByVariantId, keyA) ? unitDivisorsByVariantId[keyA] : undefined) ??
          (Object.prototype.hasOwnProperty.call(unitDivisorsByVariantId, keyB) ? unitDivisorsByVariantId[keyB] : undefined);

        const method = line.getAttribute("data-mm-unit-price-method") || "text";
        const parsePriceToCents = (raw) => {
          if (!raw) return NaN;
          // Examples: "68 €", "106,17€", "1 234,50 €"
          const cleaned = String(raw)
            .replace(/\s/g, "")
            .replace(/\u202f/g, "") // narrow no-break space
            .replace("€", "")
            .replace(",", ".");
          const num = Number(cleaned);
          if (!Number.isFinite(num)) return NaN;
          return Math.round(num * 100);
        };

        // Use the module's live-updated prices (mm-reload), not variant JSON.
        const isSticky = Boolean(line.closest("[data-mm-sticky-unit-price]"));
        let displayedPriceText;
        if (isSticky) {
          const priceRoot =
            selectedMethod === "subscription" ? document.querySelector('label[for="subscription"]') : document.querySelector('label[for="one_time"]');
          displayedPriceText = priceRoot?.querySelector(".mm-rc-option-price.mm-reload")?.textContent;
        } else {
          const labelRoot = line.closest("label") || line.closest(".mm-selling-plans-elem") || document;
          displayedPriceText = labelRoot.querySelector(".mm-rc-option-price.mm-reload")?.textContent;
        }
        const variantPriceCents = parsePriceToCents(displayedPriceText);

        // 1) Text mode (existing prix_par_dose)
        if (method === "text") {
          if (lookedUpText != null && lookedUpText !== "") {
            const normalized = String(lookedUpText).trim();
            const withCurrency = normalized.includes("€") ? normalized : `${normalized}€`;
            targets.forEach((t) => (t.textContent = withCurrency));
          }
        }

        // 2) Computed mode: variant price / unit_by_variant
        if (method === "computed") {
          const divisor = Number(String(divisorRaw || "").replace(",", "."));
          if (Number.isFinite(variantPriceCents) && Number.isFinite(divisor) && divisor > 0) {
            const unitPrice = variantPriceCents / 100 / divisor;
            const formatted = unitPrice.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            targets.forEach((t) => (t.textContent = `${formatted}€`));
          }
        }
        // Never hide the line here: Liquid provides a safe initial value and
        // settings may include text even if #unit_price# is missing.
        line.style.display = "";
      });
    } finally {
      window.mmUpdatePaymentSummary?.();
      if (document.querySelector("#one_time:checked")) {
        window.mmRestoreSubscriptionHeaderReferencePrice?.();
      }
    }
  };

  window.mmUpdateSubscriptionUpsell = function mmUpdateSubscriptionUpsell() {
    const upsellRoot = document.querySelector("[data-mm-subscription-upsell]");
    if (!upsellRoot) return;

    const parseOptionPriceToCents = (raw) => {
      if (!raw) return NaN;
      const cleaned = String(raw)
        .replace(/\s/g, "")
        .replace(/\u202f/g, "")
        .replace("€", "")
        .replace(",", ".");
      const num = Number(cleaned);
      if (!Number.isFinite(num)) return NaN;
      return Math.round(num * 100);
    };

    const selectedMethod = document.querySelector('input[name="purchase_option"]:checked')?.value || "one_time";

    const currentPriceText =
      selectedMethod === "subscription"
        ? document.querySelector("#mm-subscription-header-price")?.textContent ||
          document.querySelector(".mm-selling-plans-elem.mm-selling-plans-subscription .mm-rc-option-price.mm-reload")?.textContent ||
          ""
        : document.querySelector(".mm-selling-plans-elem.mm-selling-plans-one-shot .mm-rc-option-price.mm-reload")?.textContent || "";
    const currentPriceCents = parseOptionPriceToCents(currentPriceText);

    const thresholdEls = Array.from(upsellRoot.querySelectorAll("[data-mm-upsell-tier]"));
    const getTierPurchaseScope = (el) => el.getAttribute("data-mm-reward-scope")?.trim() || "both";
    const getThresholdCents = (el) => Number(String(el.getAttribute("data-threshold-eur") || "").replace(",", ".")) * 100;

    thresholdEls.forEach((tierEl) => {
      const thresholdCents = getThresholdCents(tierEl);
      const scope = getTierPurchaseScope(tierEl);
      const allowed = scope === "both" || scope === selectedMethod;
      const unlocked = allowed && Number.isFinite(currentPriceCents) && Number.isFinite(thresholdCents) && currentPriceCents >= thresholdCents;
      tierEl.classList.toggle("is-unlocked", unlocked);
    });

    // Update firstLine/finalLine here, in the synchronous section, before any early return.
    // Required for pack products whose DOM structure may trigger a return before the async block.
    // Show finalLine only when ALL tiers the customer is eligible for (given the current
    // purchase mode) are unlocked. Tiers scoped to a mode the customer hasn't selected are
    // excluded from the "all unlocked" check (e.g. a subscription-only gift in one_time mode).
    const _applicableTiers = thresholdEls.filter((tierEl) => {
      const scope = getTierPurchaseScope(tierEl);
      if (!(scope === "both" || scope === selectedMethod)) return false;
      const t = getThresholdCents(tierEl);
      return Number.isFinite(t) && t > 0;
    });
    const _allApplicableUnlocked =
      _applicableTiers.length > 0 &&
      Number.isFinite(currentPriceCents) &&
      _applicableTiers.every((tierEl) => currentPriceCents >= getThresholdCents(tierEl));
    const _finalLine = upsellRoot.querySelector("[data-mm-upsell-final-text]");
    const _firstLine = upsellRoot.querySelector("[data-mm-upsell-first-text]");
    if (_finalLine) _finalLine.style.display = _allApplicableUnlocked ? "block" : "none";
    if (_firstLine) _firstLine.style.display = _allApplicableUnlocked ? "none" : "block";

    const variantOptions = document.querySelector('label[for="one_time"] .mm-selling-plans-options-inputs-bis');
    if (!variantOptions) return;

    const inputs = Array.from(variantOptions.querySelectorAll('input[type="radio"]'));
    const labels = Array.from(variantOptions.querySelectorAll("label"));
    if (!inputs.length || !labels.length) return;

    const currentVariantIdFromForm = document.getElementById("product_id")?.value;
    const selectedIdxById =
      currentVariantIdFromForm != null ? inputs.findIndex((i) => String(i.getAttribute("data-variant-id") || "") === String(currentVariantIdFromForm)) : -1;
    const selectedIdxByChecked = inputs.findIndex((i) => i.checked);
    const selectedIdx = Math.max(0, selectedIdxById >= 0 ? selectedIdxById : selectedIdxByChecked);
    const nextIdx = Math.min(selectedIdx + 1, inputs.length - 1);
    const isLastVariant = inputs.length > 0 && selectedIdx >= inputs.length - 1;

    const getLabelByIndex = (i) => labels[i] || variantOptions.querySelector(`label[for="${inputs[i]?.id}"]`);
    const currentLabel = getLabelByIndex(selectedIdx);
    const nextLabel = getLabelByIndex(nextIdx);
    if (!currentLabel || !nextLabel) return;

    const currentVariantId = inputs[selectedIdx]?.getAttribute("data-variant-id");
    const nextVariantId = inputs[nextIdx]?.getAttribute("data-variant-id");

    const selectorEl = document.querySelector("variant-selector");
    const sectionId = selectorEl?.dataset?.section;
    const baseUrl = selectorEl?.dataset?.url;
    if (!sectionId || !baseUrl || !nextVariantId) return;

    // Prix affiché dans la phrase d’upsell : en général = variante « suivante » + mode actuel.
    // Dernière variante + achat unique : pas de variante supérieure → on montre le prix à l’unité
    // **abonnement** pour **cette même** variante (incitation à passer en abonnement).
    const upsellPriceReadMode =
      selectedMethod === "one_time" && isLastVariant ? "subscription" : selectedMethod;

    // unit_by_variant divisor lookup for next variant
    const divisorsScript = document.getElementById("mmVariantUnitDivisors");
    if (!divisorsScript) return;
    let divisors = {};
    try {
      divisors = JSON.parse(divisorsScript.textContent || "{}") || {};
    } catch (e) {
      return;
    }
    const nextDivisorRaw =
      (Object.prototype.hasOwnProperty.call(divisors, String(nextVariantId)) ? divisors[String(nextVariantId)] : undefined) ??
      (Object.prototype.hasOwnProperty.call(divisors, String(parseInt(nextVariantId, 10))) ? divisors[String(parseInt(nextVariantId, 10))] : undefined);
    const nextUnits = Number(String(nextDivisorRaw || "").replace(",", "."));

    /**
     * Même source que mm_subscription.js (mmSubscriptionPlanPricesByVariant + plan selling_plan_N).
     * Le fetch section renvoie du Liquid faux vs Skio ; pour une autre variante en abonnement,
     * on prend l’allocation Shopify du couple (variante cible × plan de la ligne N).
     */
    const getSubscriptionAllocationPriceCentsForUpsellTarget = (targetVariantId, targetVariantRadioIdx) => {
      const mapEl = document.getElementById("mmSubscriptionPlanPricesByVariant");
      if (!mapEl) return NaN;
      let priceMap = {};
      try {
        priceMap = JSON.parse(mapEl.textContent || "{}") || {};
      } catch (e) {
        return NaN;
      }
      const vid = String(targetVariantId);
      const byVar = priceMap[vid] ?? priceMap[String(parseInt(vid, 10))];
      if (!byVar || typeof byVar !== "object") return NaN;

      const planSlot = Number(targetVariantRadioIdx) + 1;
      const planEl = document.getElementById(`selling_plan_${planSlot}`);
      const planIdRaw = planEl?.value;
      if (planIdRaw == null || String(planIdRaw).trim() === "") return NaN;
      const pid = String(planIdRaw).trim();

      let cents = Number(byVar[pid]);
      if (!Number.isFinite(cents)) cents = Number(byVar[String(Number(pid))]);
      if (!Number.isFinite(cents)) {
        for (const k of Object.keys(byVar)) {
          if (String(k) === pid || String(Number(k)) === String(Number(pid))) {
            const v = Number(byVar[k]);
            if (Number.isFinite(v)) {
              cents = v;
              break;
            }
          }
        }
      }
      if (!Number.isFinite(cents)) {
        const fallback = document.getElementById("mmDefaultSellingPlanIdRef")?.value?.trim();
        if (fallback) {
          const c2 = Number(byVar[fallback]);
          if (Number.isFinite(c2)) cents = c2;
        }
      }
      return Number.isFinite(cents) ? cents : NaN;
    };

    const fetchCache = (window.__mmUpsellCache ||= {});
    const fetchKey = `${baseUrl}|${sectionId}|${nextVariantId}|${upsellPriceReadMode}`;
    const getDisplayedPriceTextForUpsell = async () => {
      const pageVariantId = document.getElementById("product_id")?.value;
      if (String(nextVariantId) === String(pageVariantId)) {
        const labelRoot = document.querySelector(`label[for="${upsellPriceReadMode}"]`);
        if (upsellPriceReadMode === "subscription") {
          return (
            labelRoot?.querySelector("#mm-subscription-header-price")?.textContent ||
            labelRoot?.querySelector(".mm-rc-option-price.mm-reload")?.textContent ||
            ""
          );
        }
        return labelRoot?.querySelector(".mm-rc-option-price.mm-reload")?.textContent || "";
      }
      if (fetchCache[fetchKey]) return fetchCache[fetchKey];
      const url = `${baseUrl}?variant=${nextVariantId}&section_id=${sectionId}`;
      const htmlText = await fetch(url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(htmlText, "text/html");
      const priceText =
        upsellPriceReadMode === "subscription"
          ? (
              doc.querySelector("#mm-subscription-header-price")?.textContent ||
              doc.querySelector(".mm-selling-plans-elem.mm-selling-plans-subscription .mm-rc-option-price.mm-reload")?.textContent ||
              ""
            ).trim()
          : (doc.querySelector(".mm-selling-plans-elem.mm-selling-plans-one-shot .mm-rc-option-price.mm-reload")?.textContent || "").trim();
      fetchCache[fetchKey] = priceText;
      return priceText;
    };

    // Async compute + render
    (async () => {
      const runId = String((Number(upsellRoot.dataset.mmUpsellRunId || "0") || 0) + 1);
      upsellRoot.dataset.mmUpsellRunId = runId;

      const pageVariantId = document.getElementById("product_id")?.value;
      let priceCents = NaN;

      if (upsellPriceReadMode === "subscription") {
        if (String(nextVariantId) === String(pageVariantId)) {
          const displayedPriceText = await getDisplayedPriceTextForUpsell();
          if (upsellRoot.dataset.mmUpsellRunId !== runId) return;
          priceCents = parseOptionPriceToCents(displayedPriceText);
        } else {
          priceCents = getSubscriptionAllocationPriceCentsForUpsellTarget(nextVariantId, nextIdx);
          if (!Number.isFinite(priceCents)) {
            const displayedPriceText = await getDisplayedPriceTextForUpsell();
            if (upsellRoot.dataset.mmUpsellRunId !== runId) return;
            priceCents = parseOptionPriceToCents(displayedPriceText);
          }
        }
      } else {
        const displayedPriceText = await getDisplayedPriceTextForUpsell();
        if (upsellRoot.dataset.mmUpsellRunId !== runId) return;
        priceCents = parseOptionPriceToCents(displayedPriceText);
      }

      const unitPrice = Number.isFinite(priceCents) && Number.isFinite(nextUnits) && nextUnits > 0 ? priceCents / 100 / nextUnits : NaN;
      const unitPriceFormatted = Number.isFinite(unitPrice)
        ? `${unitPrice.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€`
        : "";

      upsellRoot.querySelectorAll("[data-mm-upsell-unit-price]").forEach((el) => (el.textContent = unitPriceFormatted));

      // Compute next gift text (delta unlocked) — mêmes nœuds prix que le bandeau unitaire
      const currentPriceText =
        selectedMethod === "subscription"
          ? document.querySelector("#mm-subscription-header-price")?.textContent ||
            document.querySelector(".mm-selling-plans-elem.mm-selling-plans-subscription .mm-rc-option-price.mm-reload")?.textContent ||
            ""
          : document.querySelector(".mm-selling-plans-elem.mm-selling-plans-one-shot .mm-rc-option-price.mm-reload")?.textContent || "";
      const currentPriceCents = parseOptionPriceToCents(currentPriceText);

      const thresholdEls = Array.from(upsellRoot.querySelectorAll("[data-mm-upsell-tier]"));
      const getTierPurchaseScope = (el) => el.getAttribute("data-mm-reward-scope")?.trim() || "both";
      const getThresholdCents = (el) => Number(String(el.getAttribute("data-threshold-eur") || "").replace(",", ".")) * 100;
      const unlockedNow = thresholdEls.filter((el) => Number.isFinite(currentPriceCents) && currentPriceCents >= getThresholdCents(el));
      const unlockedNext = thresholdEls.filter((el) => Number.isFinite(priceCents) && priceCents >= getThresholdCents(el));

      const newlyUnlocked = unlockedNext.filter((el) => !unlockedNow.includes(el));
      const reward1Label = upsellRoot.querySelectorAll("[data-mm-upsell-tier]")[0]?.querySelector(".mm-upsell-reward-label")?.textContent?.trim();
      const reward2Label = upsellRoot.querySelectorAll("[data-mm-upsell-tier]")[1]?.querySelector(".mm-upsell-reward-label")?.textContent?.trim();

      const threshold1 = getThresholdCents(thresholdEls[0] || document.createElement("div"));
      const threshold2 = getThresholdCents(thresholdEls[1] || document.createElement("div"));

      const applicableRewardTiers = thresholdEls.filter((tierEl) => {
        const scope = getTierPurchaseScope(tierEl);
        if (!(scope === "both" || scope === selectedMethod)) return false;
        const t = getThresholdCents(tierEl);
        return Number.isFinite(t) && t > 0;
      });
      const hasMaxRewardsForPurchaseMode =
        applicableRewardTiers.length > 0 &&
        applicableRewardTiers.every((tierEl) => {
          const t = getThresholdCents(tierEl);
          return Number.isFinite(currentPriceCents) && Number.isFinite(t) && currentPriceCents >= t;
        });
      // Unlock tiers based on CURRENT price thresholds
      thresholdEls.forEach((tierEl) => {
        const thresholdCents = getThresholdCents(tierEl);
        const scope = getTierPurchaseScope(tierEl);
        const allowed = scope === "both" || scope === selectedMethod;
        const unlocked = allowed && Number.isFinite(currentPriceCents) && Number.isFinite(thresholdCents) && currentPriceCents >= thresholdCents;
        tierEl.classList.toggle("is-unlocked", unlocked);
      });

      const progressLine = upsellRoot.querySelector("[data-mm-upsell-progress]");
      const finalLine = upsellRoot.querySelector("[data-mm-upsell-final-text]");
      const firstLine = upsellRoot.querySelector("[data-mm-upsell-first-text]");

      // showFinal: all rewards the customer is ELIGIBLE for (given current purchase mode)
      // are unlocked. Rewards scoped to another mode (e.g. subscription-only when the
      // customer picked one-time) are excluded from the eligibility set — those gifts are
      // unreachable from this side, so they shouldn't prevent the "congrats" message.
      const showFinal = hasMaxRewardsForPurchaseMode;
      if (progressLine) progressLine.style.display = showFinal ? "none" : "block";
      if (firstLine) firstLine.style.display = showFinal ? "none" : "block";
      if (finalLine) finalLine.style.display = showFinal ? "block" : "none";

      // Set #tier_label# only when next offer reaches a tier
      const tierLabelTarget = upsellRoot.querySelector("[data-mm-upsell-tier-label]");
      if (tierLabelTarget) {
        const labelsRoot = upsellRoot.querySelector("[data-mm-upsell-tier-labels]");
        const getScope = (n) => labelsRoot?.querySelector(`[data-mm-tier-scope="${n}"]`)?.textContent?.trim() || "both";
        const getLabelHtml = (n) => labelsRoot?.querySelector(`[data-mm-tier-label="${n}"]`)?.innerHTML?.trim() || "";

        // If we couldn't compute the next price, don't wipe a previously rendered label.
        if (!Number.isFinite(priceCents)) return;

        const nowTier1 = Number.isFinite(currentPriceCents) && Number.isFinite(threshold1) && currentPriceCents >= threshold1;
        const nowTier2 = Number.isFinite(currentPriceCents) && Number.isFinite(threshold2) && currentPriceCents >= threshold2;
        const nextTier1 = Number.isFinite(priceCents) && Number.isFinite(threshold1) && priceCents >= threshold1;
        const nextTier2 = Number.isFinite(priceCents) && Number.isFinite(threshold2) && priceCents >= threshold2;

        const crosses = {
          1: nextTier1 && !nowTier1,
          2: nextTier2 && !nowTier2,
        };

        // If next offer unlocks multiple tiers, show all eligible labels (1 then 2).
        const picks = ["1", "2"].filter((n) => {
          if (!crosses[n]) return false;
          const scope = getScope(n);
          return scope === "both" || scope === selectedMethod;
        });

        const html = picks
          .map((n) => getLabelHtml(n))
          .filter(Boolean)
          .join(" ");
        tierLabelTarget.innerHTML = html ? ` ${html}` : "";
      }
    })();
  };

  // Initial render (page load) — mmUpdateUnitPrice() appelle aussi mmUpdatePaymentSummary (finally)
  window.mmUpdateUnitPrice();
  window.mmUpdateSubscriptionUpsell();

  // Also update when switching one-time/subscription
  document.querySelectorAll('input[name="purchase_option"]').forEach((inp) => {
    inp.addEventListener("change", () => {
      window.mmUpdateUnitPrice?.();
      window.mmUpdateSubscriptionUpsell?.();
    });
  });
});

// Ouverture des dropdowns
var allDropdown = document.querySelectorAll(".mm-product-form-dropdown");
allDropdown.forEach((content) => {
  content.addEventListener("click", function () {
    checkDropdown(content, false);
  });
  checkDropdown(content, true);
});
function checkDropdown(dropdown, load) {
  if (load && dropdown.classList.contains("active")) {
    const content = dropdown.nextElementSibling;
    // Delete after ab test
    if (document.querySelectorAll(".mm-product-form-dropdown.active").length > 1) {
      content.style.height = "auto";
    } else {
      if (dropdown.classList.contains("mm-product-form-dropdown-science")) {
        content.style.height = "auto";
      } else {
        let height = content.scrollHeight;
        content.style.height = height + "px";
      }
    }
  } else if (!load) {
    dropdown.classList.toggle("active");
    const content = dropdown.nextElementSibling;
    if (content.style.height) {
      content.style.height = null;
    } else {
      if (dropdown.classList.contains("mm-product-form-dropdown-science")) {
        content.style.height = "auto";
      } else {
        let height = content.scrollHeight;
        content.style.height = height + "px";
      }
    }
    allDropdown.forEach((elem) => {
      if (elem != dropdown) {
        elem.classList.remove("active");
        elem.nextElementSibling.style.height = null;
      }
    });
  }
}

// STICKY CTA DISPLAY ONLY WHEN SCROLL AFTER TRUE CTA
var derniere_position_de_scroll_connue = 0;
var ticking = false;
var CTA = document.querySelector(".mm-main-product-button-container");
var CTA_position = CTA.offsetTop - window.screen.height / 3;

function mmSyncUnitPriceIntoStickyCta() {
  if (!CTA) return;
  const stickyHost = CTA;
  const existing = stickyHost.querySelector("[data-mm-sticky-unit-price]");

  // Only render inside sticky state
  if (!CTA.classList.contains("mm-cta-sticky")) {
    if (existing) existing.remove();
    return;
  }

  // Source: unit price line from subscription module (layout winner)
  const source =
    document.querySelector(".mm-selling-plans-elem.mm-selling-plans-subscription [data-mm-unit-price-line]") ||
    document.querySelector("[data-mm-unit-price-line]");

  if (!source) {
    if (existing) existing.remove();
    return;
  }

  const stickyEnabled = (source.getAttribute("data-mm-unit-price-sticky-enabled") || "true").toLowerCase() !== "false";
  if (!stickyEnabled) {
    if (existing) existing.remove();
    return;
  }

  if (!existing) {
    const wrapper = document.createElement("div");
    wrapper.setAttribute("data-mm-sticky-unit-price", "true");
    wrapper.className = "mm-sticky-unit-price";

    const clone = source.cloneNode(true);
    clone.style.display = "";
    wrapper.appendChild(clone);

    const button = stickyHost.querySelector(".mm-btn-primary");
    if (button) stickyHost.insertBefore(wrapper, button);
    else stickyHost.appendChild(wrapper);

    // Ensure content is up-to-date after clone
    window.mmUpdateUnitPrice?.();
  }
}

function showHideCta(position_scroll) {
  if (position_scroll > CTA_position) {
    CTA.classList.add("mm-cta-sticky");
  } else {
    CTA.classList.remove("mm-cta-sticky");
  }
  mmSyncUnitPriceIntoStickyCta();
}
if (window.innerWidth < 768) {
  // Faire quelque chose en mobile seulement
  window.addEventListener("scroll", function (e) {
    derniere_position_de_scroll_connue = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        showHideCta(derniere_position_de_scroll_connue);
        ticking = false;
      });
    }

    ticking = true;
  });
}

class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.cached = {};
    this.container = this.closest("#mm-main-product-container");
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();
    this.updateKlarna(this.currentVariant);
    window.mmUpdateUnitPrice?.();
    window.mmUpdateSubscriptionUpsell?.();

    if (this.currentVariant) {
      this.outOfStock(this.currentVariant.available);
      this.updateURL();
      this.variantFetch();
      this.selectMedia();
    }
  }

  updateKlarna(variant) {
    const subscriptionLabel = document.querySelector(".mm-rc-subscription-label");
    const klarnaContainer = document.getElementById("klarna-widget-container");
    const klarnaAppContainer = document.querySelector(".shopify-app-block:has(klarna-placement)");

    if (subscriptionLabel && subscriptionLabel.classList.contains("mm-open")) {
      if (klarnaAppContainer) klarnaAppContainer.style.display = "none";
      if (klarnaContainer) klarnaContainer.style.display = "none";
      return;
    }

    if (variant && variant.price >= 5000) {
      if (klarnaAppContainer) klarnaAppContainer.style.display = "block";
      if (klarnaContainer) klarnaContainer.style.display = "none";
    } else {
      if (klarnaAppContainer) klarnaAppContainer.style.display = "none";
      if (klarnaContainer) klarnaContainer.style.display = "block";
    }
  }

  getSelectedOptions() {
    this.options = [];
    this.querySelectorAll(".mm-product-variant-picker-container").forEach((box) => {
      const inp = box.querySelector(".mm-product-variant-checkbox:checked");
      if (inp && !(inp.name || "").endsWith("-bis")) {
        this.options.push(inp.value);
      }
    });
    if (this.options.length === 0) {
      const root = this.closest("#mm-main-product-container");
      if (root) {
        root.querySelectorAll(".mm-selling-plans-options-inputs-bis .mm-product-variant-checkbox:checked").forEach((inp) => this.options.push(inp.value));
      }
    }
    return this.options;
  }

  /** Après variantFetch, le HTML section remet souvent la variante par défaut Liquid sur les radios. */
  syncPickerToCurrentVariant() {
    if (!this.currentVariant?.options?.length) return;
    const boxes = this.container.querySelectorAll(".mm-product-variant-picker-container");
    this.currentVariant.options.forEach((val, i) => {
      if (val == null || !boxes[i]) return;
      boxes[i].querySelectorAll(".mm-product-variant-checkbox").forEach((input) => {
        input.checked = input.value === val;
      });
    });
  }

  getVariantJSON() {
    this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);

      if (findings) return variant;
    });
  }

  updateURL() {
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  variantFetch() {
    var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

    if (this.cached[variantUrl]) {
      this.renderVariantInfo(this.cached[variantUrl]);
      return;
    }

    fetch(variantUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.cached[variantUrl] = html;
        this.renderVariantInfo(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderVariantInfo(html) {
    this.updateElementsOuter("#product_id", html);
    this.updateElementsOuter(".mm-main-product-tags-container", html);
    this.updateElementsOuter(".mm-product-form-component-format", html);
    this.updateElementsOuter(".mm-product-variant-picker-container", html);
    //this.updateElementsOuter(".mm-main-product-button-container", html);
    this.updateElementsOuter("#mmSubscriptionPlanPricesByVariant", html);
    this.updateElementsOuter("#mmDefaultSellingPlanIdRef", html);
    this.updateElementsOuter(".mm-reload", html);
    this.syncPickerToCurrentVariant();
    const oneTimeSelected = Boolean(document.querySelector("#one_time:checked"));
    if (oneTimeSelected) {
      window.mmRestoreSubscriptionHeaderReferencePrice?.();
    } else {
      window.mmSyncSubscriptionAllocationPrice?.();
    }
    window.mmUpdateUnitPrice?.();
    window.mmUpdateSubscriptionUpsell?.();
    window.mmUpdateHoverImageDiscountBadge?.();
    if (oneTimeSelected) {
      window.mmRestoreSubscriptionHeaderReferencePrice?.();
    }
  }

  outOfStock(available) {
    const MM_KLAVIYO = document.querySelector(".mm-klaviyo");
    const MM_BUTTON_PRIMARY_TEXTS = document.querySelector(".mm-button-primary--texts");
    const MM_BUTTON_PRIMARY = document.querySelector(".mm-btn-primary");
    if (!available) {
      MM_KLAVIYO.style.display = "inline-block";
      MM_BUTTON_PRIMARY_TEXTS.style.display = "none";
      MM_BUTTON_PRIMARY.dataset.available = "false";
    } else {
      MM_KLAVIYO.style.display = "none";
      MM_BUTTON_PRIMARY_TEXTS.style.display = "inline-block";
      MM_BUTTON_PRIMARY.dataset.available = "true";
    }
  }

  selectMedia() {
    const first_media = document.querySelector(`.mm-thumbnail-elem[data-index="0"]`);
    // Utiliser une approche différente pour trouver le media correspondant à la variante actuelle
    let media_to_select = null;

    // Récupérer tous les thumbnails
    const all_thumbnails = document.querySelectorAll(".mm-thumbnail-elem");

    // Parcourir chaque thumbnail pour vérifier si l'ID de la variante actuelle est inclus
    for (const thumbnail of all_thumbnails) {
      const variant_ids = thumbnail.getAttribute("data-variant-id");

      // Si l'attribut data-variant-id contient l'ID de la variante actuelle
      if (variant_ids && variant_ids.split(" ").includes(this.currentVariant.id.toString())) {
        media_to_select = thumbnail;
        break;
      }
    }

    // S'il n'y a pas de correspondance exacte, essayons l'ancienne méthode
    if (!media_to_select) {
      media_to_select = document.querySelector(`.mm-thumbnail-elem[data-variant-id="${this.currentVariant.id}"]`);
    }

    const media_click_event = new Event("click");
    if (media_to_select) {
      media_to_select.dispatchEvent(media_click_event);
    } else {
      first_media.dispatchEvent(media_click_event);
    }
  }

  updateElement(selector, html) {
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateElementsOuter(selector, html) {
    const destinations = this.container.querySelectorAll(selector);
    const sources = html.querySelectorAll(selector);

    destinations.forEach((destination, index) => {
      const source = sources[index];
      if (source) {
        destination.outerHTML = source.outerHTML;
      }
    });
  }
}
customElements.define("variant-selector", VariantSelector);

document.addEventListener("DOMContentLoaded", (event) => {
  const variantSelector = document.querySelector("variant-selector");
  if (variantSelector) {
    const select_variant = new Event("change");
    variantSelector.dispatchEvent(select_variant);
    // Appliquer l'état Klarna au chargement (abonnement coché par défaut = masquer Klarna)
    requestAnimationFrame(() => {
      variantSelector.getSelectedOptions();
      variantSelector.getSelectedVariant();
      variantSelector.updateKlarna(variantSelector.currentVariant);
    });
  }
});

const DUREE_ELEM = document.querySelector("#mmDureeInfo > span");

function mmChangeDuree(duree) {
  if (!DUREE_ELEM) return;
  DUREE_ELEM.innerText = duree;
}

function mmSetupDuree() {
  const duree = document.querySelector(".mm-product-variant-picker-container .mm-product-variant-checkbox:checked");
  if (duree) {
    const dureeData = duree.dataset.duree;
    DUREE_ELEM.innerText = dureeData;
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  mmSetupDuree();
});

// Klarna
document.addEventListener("DOMContentLoaded", () => {
  // Sélectionner l'élément où afficher le message
  const messageContainer = document.getElementById("message-container");

  document.querySelectorAll('input[type="radio"][name="purchase_option"]').forEach((radioButton) => {
    radioButton.addEventListener("change", function () {
      if (radioButton && radioButton.checked) {
        const klarnaContainer = document.getElementById("klarna-widget-container");
        const klarnaAppContainer = document.querySelector(".shopify-app-block:has(klarna-placement)");
        const klarnaPlacement = document.querySelector(".shopify-app-block klarna-placement");

        const variantPrice = parseInt(klarnaPlacement.dataset.purchaseAmount);

        if (radioButton.value === "one_time") {
          if (variantPrice >= 5000) {
            klarnaAppContainer.style.display = "block"; // Affiche le widget Klarna de l'App Klarna
            klarnaContainer.style.display = "none"; // Affiche le widget Klarna
          } else {
            klarnaAppContainer.style.display = "none"; // Affiche le widget Klarna de l'App Klarna
            klarnaContainer.style.display = "block"; // Affiche le widget Klarna
          }
        } else {
          klarnaAppContainer.style.display = "none"; // Masque le widget Klarna de l'App Klarna
          klarnaContainer.style.display = "none"; // Masque le widget Klarna
        }
      }
    });
  });
});
